module.exports = __webpack_public_path__ + "static/img/2017.53b90cb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/2017.png
// module id = t1s2
// module chunks = 1